import _debounce from 'lodash/debounce';
import { getGraphQLClientInsights } from '../../../utilities/graphql';
import * as loggerx from '../../../utilities/loggerx';

import PlayIntervals from '../../../utilities/video-session/playIntervals.graphql';

interface WatchedIntervals {
  videoId: string;
  buckets: boolean[];
}

const DEBOUNCE_WAIT_MS = 900;
const DEBOUNCE_MAX_WAIT_MS = 1500;

async function syncIntervals(
  watchedIntervals: WatchedIntervals
): Promise<void> {
  loggerx.addCrumb({
    message: 'sending intervals',
    context: watchedIntervals,
  });

  try {
    const { data } = await sendMutation(PlayIntervals, watchedIntervals);

    const payload = data?.updateVideoPlayInterval;

    if (payload?.message) {
      loggerx.error(payload.message);
    }
  } catch (err) {
    loggerx.error(err, {
      intervals: watchedIntervals,
    });
  }
}

function sendMutation(mutation: unknown, watchedIntervals: WatchedIntervals) {
  const client = getGraphQLClientInsights();

  return client.mutate({
    mutation,
    variables: { watchedIntervals },
  });
}

type IntervalSync = (wI: WatchedIntervals) => Promise<void> | undefined;

export default (): IntervalSync =>
  _debounce(syncIntervals, DEBOUNCE_WAIT_MS, {
    maxWait: DEBOUNCE_MAX_WAIT_MS,
  });
